import React, { Component, createRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong, faCheck, faListCheck, faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import InventoryServices from "../../services/axioServices/apiServices/InventoryServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import {
  isValidForm,
  validate,
} from "../../utils/validation/CommonValidator.js";
import { CommonSuccessMessages, CommonValidationMessages } from "../../utils/Messages.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import moment from "moment";
import ProductionServices from "../../services/axioServices/apiServices/ProductionServices.js";
import ProductionPMSlipModel from "../../components/production/ProductionPMSlip.js";
import Breadcrumb from "../component/Breadcumb.js";
import { Navigate } from "react-router-dom";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";

class PackingRequisition extends Component {
  constructor(props) {
    super(props);
    this.printRef = createRef();
    this.inventoryServices = new InventoryServices();
    this.productionServices = new ProductionServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      isPharmaSoftware: false,
      route: null,
      tableStatus: "",
      isLoading: false,
      isGridView: true,
      isQtyEditingKey: null,
      isQtyEditing: false,
      setRMSlipModel: false,
      isPrintButtonHide: false,
      companyItemList: [],
      productionRequisitionList: [],
      productDropdownList: [],
      pmFormulaList: [],
      updatedQty: 0,
      filterDetails: {
        partyName: "",
        productName: "",
        filterBy: "",
        productionStageId: [3],
      },
      filterByList: [
        { filterBy: "Prod No.", value: "productionNo" },
        { filterBy: "Batch No", value: "batchNo" },
        { filterBy: "Batch Size", value: "batchSize" },
      ],
      productionTypeList: [
        // { type: "Production Planning", value: 1 },
        // { type: "Production Requisition", value: 2 },
        { type: "Packing Requisition", value: 3 },
        { type: "Pending Batches", value: 4 },
      ],
      packingDetails: {
        productDetialsId: "",
        productionNo: "",
        batchNo: "",
        batchSize: "",
        stdBatchSize: "",
        productId: "",
        mfgDate: "",
        expDate: "",
        size: "",
        colour: "",
        productionStageStatusId: 0,
        packingItemId: "",
        packQty: 0,
        packingRequisitionReqDate: "",
        isPMFormulaCreated: false,
        qcStatus: '',
        labTestRequire: false,
      },
      validationRules: {
        productionNo: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "slip no"
            ),
          },
        ],
        batchNo: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "batch no"
            ),
          },
        ],
        batchSize: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "batch size"
            ),
          },
        ],
        productId: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "product name"
            ),
          },
        ],
        mfgDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "mfg. date"
            ),
          },
        ],
        expDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "exp. date"
            ),
          },
        ],
        packingItemId: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "packing item"
            ),
          },
        ],
        packQty: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "pack quantity"
            ),
          },
          {
            type: "number",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "valid number"
            ),
          },
        ],
        packingRequisitionReqDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "req. date"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    this.getAllProductionPlanningEntry();

    let cookies = getAuthProps()
    if (cookies) {
      this.setState({ isPharmaSoftware: cookies.isPharmaSoftware })
    }
  }

  getAllProductionPlanningEntry = () => {
    this.setState({ tableStatus: "Loading..." })
    let request = this.state.filterDetails;
    this.productionServices
      .getAllProductionPlanningEntry(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let res = response.responseData;
          if (response.responseData.length === 0) {
            this.setState({ tableStatus: "No Record Found" })
          } else {
            this.setState({ tableStatus: "" })
          }
          this.setState({ productionRequisitionList: res }, () => {
            this.getAllProductDropdown();
          });
        } else {
          this.getAllProductDropdown();
          this.SwalServices.Error(
            response.Message
          );
          this.setState({ tableStatus: "" })
        }
      });
  };

  getAllProductDropdown = () => {
    this.commonServices.getAllProductDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.productName,
          value: item._id,
        }));
        this.setState({ productDropdownList: dropdownItems }, () => {
          this.getAllItem();
        });
      } else {
        this.getAllItem();
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  getAllItem = () => {
    this.commonServices.getAllItem().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.ItemName,
          value: item._id,
          packing: item.Packing,
        }));

        this.setState({ companyItemList: dropdownItems });
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.packingDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  generateSlipForPackingRequisition = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      this.setState({ isLoading: true }, () => {
        let itemList = this.state.pmFormulaList;
        let isValidStock = !itemList.some(
          (item) =>
            Number(item.netQty) >
            Number(item.totalStock)
        );
        if (isValidStock) {
          this.addEditProductionPlanningEntry();
        } else {
          this.SwalServices.Alert("Please check your stock");
          this.setState({ isLoading: false });
        }
      })
    }
  };

  addEditProductionPlanningEntry = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      let request = this.state.packingDetails;
      if (request.productDetialsId === "") {
        delete request.productDetialsId;
      }
      request.productionStageId = 4;
      request.isPMFormulaCreated = true;
      this.productionServices
        .addEditProductionPlanningEntry(request)
        .then((response) => {
          if (response.statusCode === 200 && response.responseData !== null) {
            this.packingRequisitionPMFormulaListing();
          } else {
            this.packingRequisitionPMFormulaListing();
            this.SwalServices.Error(
              response.Message
            );
          }
        });
    }
  };

  packingRequisitionPMFormulaListing = () => {
    let request = {};
    request.pmFormulaArray = this.state.pmFormulaList;
    request.pmFormulaArray.map((x) => {
      x.productDetialsId = this.state.packingDetails.productDetialsId;
    });
    request.packingItemId = this.state.packingDetails.packingItemId;
    request.productDetialsId = this.state.packingDetails.productDetialsId;
    this.productionServices
      .packingRequisitionPMFormulaListing(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData !== null) {
          this.setState({ setRMSlipModel: true, isLoading: false }, () => {
            this.getAllProductionPlanningEntry()
            this.setState({ isGridView: true });
          });
        } else {
          this.SwalServices.Error(
            response.Message
          );
          this.setState({ isLoading: false })
        }
      });
  };

  setFilterParameters = (selected, drpIdentity) => {
    let details = this.state.packingDetails;
    if (drpIdentity === "packingItemId") {
      details[drpIdentity] = selected.value;
      this.setState({ packingDetails: details }, () => {
        this.getPMFormulaByPackingItemId(
          this.state.packingDetails.packingItemId
        );
      });
    } else {
      details[drpIdentity] = selected.value;
      this.setState({ packingDetails: details });
    }
  };

  handleChange = (event, name, section) => {
    let value = event.target.value;
    if (section === "filterDetails") {
      let details = this.state.filterDetails;
      details[name] = value.toUpperCase();
      this.setState({ filterDetails: details }, () => {
        this.getAllProductionPlanningEntry();
      });
    } else {
      let details = this.state.packingDetails;
      details[name] = value.toUpperCase();
      if (name === 'packQty') {
        this.getPMFormulaByPackingItemId(this.state.packingDetails.packingItemId);
      }
      this.setState({ packingDetails: details });
    }
  };

  handleDropDownChange = (event, name) => {
    const select = event.target.value;
    let details = this.state.filterDetails;
    if (name === 'productionStageId') {
      details.productionStageId = [Number(select)]
    } else {
      details[name] = select;
    }
    this.setState({ filterDetails: details }, () => {
      this.getAllProductionPlanningEntry();
    });

  };

  closeGridView = () => {
    this.setState({ isGridView: false });
  };
  openGridView = () => {
    this.resetForm();
    this.setState({ isGridView: true });
  };

  resetForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let filterDetails = this.state.filterDetails;
    filterDetails.partyName = "";
    filterDetails.productName = "";
    filterDetails.filterBy = "";
    // filterDetails.productionStageId = [3];
    let details = this.state.packingDetails;
    details.productionNo = "";
    details.batchNo = "";
    details.batchSize = "";
    details.mfgDate = "";
    details.productId = "";
    details.expDate = "";
    details.packingItemId = "";
    details.packQty = "";
    details.packingRequisitionReqDate = "";
    this.setState({ productDetails: details, validState: validState, filterDetails: filterDetails, isQtyEditingKey: null }, () => {
      this.getAllProductionPlanningEntry();
    });
  };

  getPMFormulaByPackingItemId = (id) => {
    this.productionServices.getPMFormulaByPackingItemId(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let array = response.responseData;
        array.map((product) => {
          product.totalStock = Number(product.totalStock).toFixed(3);
          product.netQty = (Number(product.netQty) / Number(product.batchSize === 0 ? 1 : product.batchSize) * (Number(this.state.packingDetails.packQty) > 0 ? Number(this.state.packingDetails.packQty) : 1)).toFixed(3);
        });
        this.setState({ pmFormulaList: array, isGridView: false });
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  getProductionPlanningEntryById = (id) => {
    this.productionServices
      .getProductionPlanningEntryById(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let details = this.state.packingDetails;
          let res = response.responseData;
          details.productionNo = res.productionNo;
          details.batchNo = res.batchNo;
          details.batchSize = res.batchSize;
          details.stdBatchSize = res.stdBatchSize ? res.stdBatchSize : "";
          details.productId = res.productId ? res.productId._id : "";
          details.productName = res.productId ? res.productId.productName : "";
          details.size = res.productId ? res.productId.sizeName : "";
          details.colour = res.productId ? res.productId.color : "";
          details.productDetialsId = res._id ? res._id : "";
          details.mfgDate = res.mfgDate
            ? moment(res.mfgDate).format("yyyy-MM-DD")
            : "";
          details.expDate = res.expDate
            ? moment(res.expDate).format("yyyy-MM-DD")
            : "";
          details.packingRequisitionReqDate = res.packingRequisitionReqDate
            ? moment(res.packingRequisitionReqDate).format("yyyy-MM-DD")
            : "";
          details.stdBatchSize = res.stdBatchSize ? res.stdBatchSize : "";
          details.productionStageStatusId =
            res.productionStageStatusId.productionStageId;
          details.packingItemId = res.packingItemId ? res.packingItemId : "";
          details.packQty = res.packQty;
          details.packingItemId = res.itemId ? res.itemId : '';
          details.packQty = res.batchSize ? res.batchSize : 0;
          details.isPMFormulaCreated = res.isPMFormulaCreated ? res.isPMFormulaCreated : false
          details.qcStatus = res.qcStatus ? res.qcStatus : "";
          details.labTestRequire = res.productId.labTestRequire ? res.productId.labTestRequire : false;

          this.setState({ packingDetails: details, isGridView: false }, () => {
            // if (this.state.packingDetails.productionStageStatusId >= 4 || res.isPMFormulaCreated === true) {
            if (this.state.packingDetails.productionStageStatusId >= 4 || res.isPMFormulaCreated === true) {
              this.getProductionPMFOrmulaByProductionDetailsId(
                this.state.packingDetails.productDetialsId
              );
            } else {
              if (this.state.packingDetails.packingItemId !== "") {
                this.getPMFormulaByPackingItemId(
                  this.state.packingDetails.packingItemId
                );
              }
            }
          });
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  removeProductionPlanningEntryFromPackingRequisition = (id) => {
    this.SwalServices.Confirm(
      "",
      ``,
      CommonSuccessMessages.Yes_Text,
      CommonSuccessMessages.No_Text,
      `Are you sure you want to delete?`
    ).then((response) => {
      if (response === true) {
        this.productionServices.removeProductionPlanningEntryFromPackingRequisition(id).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.getAllProductionPlanningEntry()
            this.SwalServices.Success(response.Message)
          } else {
            this.SwalServices.Error(response.Message);
          }
        });
      }
    })
  }

  getProductionPMFOrmulaByProductionDetailsId = (id) => {
    this.productionServices
      .getProductionPMFOrmulaByProductionDetailsId(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let array = response.responseData;
          this.setState({ pmFormulaList: array, isGridView: false });
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  handleQtyChange = (event) => {
    let value = event.target.value;
    this.setState({ updatedQty: value });
  };

  updateQtyForPMFormula = (item, index) => {
    const itemList = [...this.state.pmFormulaList];
    itemList[index] = {
      ...itemList[index],
      netQty: Number(this.state.updatedQty),
      isUpdatedQty: true,
    };
    this.setState(
      { pmFormulaList: itemList, isQtyEditing: false, isQtyEditingKey: null },);
  };

  printSlip = () => {
    this.setState({ setRMSlipModel: true });
  };

  setOpenModel = () => {
    this.setState({ setRMSlipModel: !this.state.setRMSlipModel });
  };

  printData = () => {
    const printContent = this.printRef.current;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent.innerHTML;
    window.print();

    document.body.innerHTML = originalContent;
    window.location.reload();

    // this.setState({ isPrintButtonHide: true }, () => {
    //   window.print();
    //   this.setState({ setRMSlipModel: false, isPrintButtonHide: false });
    // });
  };

  render() {
    const activePage = "Packing Requisition";
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <>
        <div className="packingRequisition-page">
          {this.state.isGridView === true ? (
            <>
              {/* <Breadcrumb page={activePage} /> */}
              <div className='flex gap-[8px] items-center mb-[8px]'>
                {/* <div className="h-[20px] w-[20px]"><FontAwesomeIcon icon={faListCheck} style={{ height: "100%", width: "100%", }} /></div> */}
                {/* <img
                  src="clipboard.png"
                  alt="A placeholder image"
                /> */}
                <p className='text-lg font-bold text-gray-700'>Packing Requisition</p>
              </div>
              <div className="item-search">
                <div className="item-grp grid grid-cols-4 gap-2.5">
                  {/* <div className="search-grp">
                    <label>Party Name:</label>
                    <input
                      type="text"
                      id="partyName"
                      name="partyName"
                      autoComplete="off"
                      className="inputFocus w-full"
                      value={this.state.filterDetails.partyName}
                      onChange={(event) =>
                        this.handleChange(event, "partyName", "filterDetails")
                      }
                    />
                  </div> */}
                  <div className="search-grp">
                    <label>Product Name:</label>
                    <input
                      type="text"
                      id="productName"
                      name="productName"
                      autoComplete="off"
                      className="inputFocus w-full"
                      value={this.state.filterDetails.productName}
                      onChange={(event) =>
                        this.handleChange(event, "productName", "filterDetails")
                      }
                    />
                  </div>
                  <div className="search-grp">
                    <label>Filter By:</label>
                    <select
                      name="filterBy"
                      className="w-full"
                      value={this.state.filterDetails.filterBy}
                      onChange={(event) =>
                        this.handleDropDownChange(
                          event,
                          "filterBy",
                          "filterDetails"
                        )
                      }
                    >
                      <option>Select</option>
                      {this.state.filterByList.map((x, key) => (
                        <option key={key} value={x.value}>
                          {x.filterBy}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="search-grp">
                    <label>Production Stage:</label>
                    <select
                      name="filterBby"
                      value={this.state.filterDetails.productionStageId}
                      onChange={(event) =>
                        this.handleDropDownChange(
                          event,
                          "productionStageId",
                          "filterDetails"
                        )
                      }
                    >
                      {this.state.productionTypeList.map((x, key) => (
                        <option key={key} value={x.value}>
                          {x.type}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="itemList-table">
                <div className="table-container" style={{ height: 'calc(100vh - 160px)' }}>
                  <table className="itemList">
                    <thead>
                      <tr>
                        <td style={{ width: "10%" }}>Prod.No</td>
                        <td style={{ width: "10%" }}>Prod.Date</td>
                        <td style={{ width: "20%" }}>Product Name</td>
                        <td style={{ width: "10%" }}>Batch No</td>
                        <td style={{ width: "10%" }}>Batch Size</td>
                        <td style={{ width: "15%" }}>Status</td>
                        {this.state.isPharmaSoftware ?
                          <td style={{ width: "15%" }}>QC Status</td>
                          : null}
                        <td style={{ width: "10%", textAlign: "center" }}>
                          Action
                        </td>
                      </tr>
                    </thead>
                    {this.state.productionRequisitionList &&
                      this.state.productionRequisitionList.length > 0 ? (
                      this.state.productionRequisitionList.map((item, key) => (
                        <tbody key={key}>
                          <tr>
                            <td>{item.productionNo}</td>
                            <td>{item.productionPlanningDate ? moment(item.productionPlanningDate).format("DD MMM yyyy") : ""}</td>
                            <td>{item.productId?.productName ? item.productId?.productName : ""}</td>
                            <td>{item.batchNo}</td>
                            <td>{item.batchSize}</td>
                            <td>{item.productionStageStatusId?.productionStageName}</td>
                            {this.state.isPharmaSoftware ?
                              <td>{item.qcStatus}</td>
                              : null}
                            <td style={{ textAlign: "center" }}>
                              <button
                                className="search-btn"
                                onClick={() =>
                                  this.getProductionPlanningEntryById(item._id)
                                }
                                title="Edit"
                              >
                                <FontAwesomeIcon icon={faPen} />
                              </button>
                              {item.productionStageStatusId.productionStageId === 3 ?
                                <button
                                  className="cancel-btn"
                                  onClick={() => this.removeProductionPlanningEntryFromPackingRequisition(item._id)}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                                : null}
                            </td>
                          </tr>
                        </tbody>
                      ))
                    ) : this.state.productionRequisitionList
                      && this.state.productionRequisitionList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={8} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.productionRequisitionList
                      && this.state.productionRequisitionList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                  </table>
                </div>
              </div>
            </>
          ) : null}

          {this.state.isGridView === false ? (
            <div className="item-listing">
              <div className="item-form">
                <div className="form-table">
                  <div className="item-grp grid grid-cols-4 !gap-[10px]">
                    <div className="input-grp">
                      <label>Prod No.</label>
                      <input
                        type="text"
                        id="productionNo"
                        name="productionNo"
                        autoComplete="off"
                        disabled
                        value={this.state.packingDetails.productionNo}
                        onChange={(event) =>
                          this.handleChange(
                            event,
                            "productionNo",
                            "packingDetails"
                          )
                        }
                      />
                      {/* <ValidationText
                        error={this.state.validState.error.productionNo}
                      /> */}
                    </div>
                    <div className="input-grp">
                      <label>Batch No</label>
                      <input
                        type="text"
                        id="batchNo"
                        name="batchNo"
                        autoComplete="off"
                        disabled
                        value={this.state.packingDetails.batchNo}
                        onChange={(event) =>
                          this.handleChange(event, "batchNo", "packingDetails")
                        }
                      />
                      {/* <ValidationText
                        error={this.state.validState.error.batchNo}
                      /> */}
                    </div>
                    <div className="input-grp">
                      <label>Batch Size</label>
                      <input
                        type="number"
                        id="batchSize"
                        name="batchSize"
                        autoComplete="off"
                        disabled
                        value={this.state.packingDetails.batchSize}
                        onChange={(event) =>
                          this.handleChange(
                            event,
                            "batchSize",
                            "packingDetails"
                          )
                        }
                      />
                      {/* <ValidationText
                        error={this.state.validState.error.batchSize}
                      /> */}
                    </div>
                    <div className="input-grp">
                      <label>MFg. Date</label>
                      <input
                        type="date"
                        id="mfgDate"
                        name="mfgDate"
                        autoComplete="off"
                        disabled
                        value={this.state.packingDetails.mfgDate}
                        onChange={(event) =>
                          this.handleChange(event, "mfgDate", "packingDetails")
                        }
                      />
                      {/* <ValidationText
                        error={this.state.validState.error.mfgDate}
                      /> */}
                    </div>
                  </div>
                  <div className="item-out-grp">
                    <div className="item-inner-grp flex gap-2.5 mt-3">
                      <div className="input-grp w-2/4">
                        <label>Product Name</label>
                        <MultiSelectDropdown
                          drpIdentity="productId"
                          options={this.state.productDropdownList}
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={(selected) =>
                            this.setFilterParameters(selected, "productId")
                          }
                          allowSelectAll={false}
                          value={this.state.productDropdownList.filter(
                            (party) =>
                              party.value ===
                              this.state.packingDetails.productId
                          )}
                          isDisabled={true}
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.productId}
                        /> */}
                      </div>
                      <div className="input-grp w-1/4">
                        <label>QC Status</label>
                        <input
                          type="text"
                          id="qcStatus"
                          name="qcStatus"
                          autoComplete="off"
                          disabled
                          value={this.state.packingDetails.qcStatus}
                          onChange={(event) =>
                            this.handleChange(
                              event,
                              "qcStatus",
                              "packingDetails"
                            )
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.qcStatus}
                        /> */}
                      </div>
                      <div className="input-grp w-1/4">
                        <label>Exp. Date</label>
                        <input
                          type="date"
                          id="expDate"
                          name="expDate"
                          autoComplete="off"
                          disabled
                          value={this.state.packingDetails.expDate}
                          onChange={(event) =>
                            this.handleChange(
                              event,
                              "expDate",
                              "packingDetails"
                            )
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.expDate}
                        /> */}
                      </div>
                    </div>
                    <div className="item-inner-grp flex gap-2.5 mt-3">
                      <div className="input-grp w-1/2">
                        <label>Packing Item</label>
                        <MultiSelectDropdown
                          className={`  ${this.state.validState?.error?.packingItemId ? "errorInput" : ""}`}
                          drpIdentity="packingItemId"
                          options={this.state.companyItemList}
                          // isMulti
                          // components={{
                          //   Option
                          // }}
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={(selected) =>
                            this.setFilterParameters(selected, "packingItemId")
                          }
                          allowSelectAll={false}
                          value={this.state.companyItemList.filter(
                            (party) =>
                              party.value ===
                              this.state.packingDetails.packingItemId
                          )}
                          isDisabled={
                            this.state.packingDetails.productionStageStatusId >=
                              4
                              ? true
                              : false
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.packingItemId}
                        /> */}
                      </div>
                      <div className="input-grp w-1/4">
                        <label>Pack. Qty.</label>
                        <input
                          type="text"
                          id="packQty"
                          name="packQty"
                          autoComplete="off"
                          className={` inputFocus ${this.state.validState?.error?.packQty ? "errorInput" : ""}`}
                          disabled={this.state.packingDetails.productionStageStatusId >= 4 || this.state.packingDetails.isPMFormulaCreated === true}
                          value={this.state.packingDetails.packQty}
                          onChange={(event) =>
                            this.handleChange(
                              event,
                              "packQty",
                              "packingDetails"
                            )
                          }
                        // onBlur={() => this.validateField('packQty')}
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.packQty}
                        /> */}
                      </div>

                      <div className="input-grp w-1/4">
                        <label>Req. Date</label>
                        <input
                          type="date"
                          id="packingRequisitionReqDate"
                          name="packingRequisitionReqDate"
                          autoComplete="off"
                          className={` inputFocus ${this.state.validState?.error?.packingRequisitionReqDate ? "errorInput" : ""}`}
                          disabled={this.state.packingDetails.productionStageStatusId >= 4 || this.state.packingDetails.isPMFormulaCreated === true}
                          value={
                            this.state.packingDetails.packingRequisitionReqDate
                          }
                          onChange={(event) =>
                            this.handleChange(
                              event,
                              "packingRequisitionReqDate",
                              "packingDetails"
                            )
                          }
                        />
                        {/* <ValidationText
                          error={
                            this.state.validState.error
                              .packingRequisitionReqDate
                          }
                        /> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="btn-grp flex gap-2.5 mt-3">
                  <button
                    className="add-btn"
                    disabled={
                      this.state.packingDetails.productionStageStatusId >= 4 ||
                      this.state.isLoading ||
                      (
                        this.state.packingDetails.labTestRequire === true &&
                        (
                          this.state.packingDetails.qcStatus === 'Not started' ||
                          this.state.packingDetails.qcStatus === 'In progress'
                        )
                      )
                    }
                    onClick={() => {
                      this.generateSlipForPackingRequisition();
                    }}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Generate slip"}
                  </button>
                  <button
                    className="cancel-btn"
                    onClick={() => this.openGridView()}
                    disabled={this.state.isLoading}
                  >
                    Cancel
                  </button>
                  {this.state.packingDetails.productionStageStatusId >= 4 || this.state.packingDetails.isPMFormulaCreated === true ? (
                    <button
                      className={`print-btn`}
                      onClick={() => this.printSlip()}
                    >
                      Print Slip
                    </button>
                  ) : null}
                  {this.state.isPharmaSoftware ?
                    <>
                      {this.state.packingDetails.qcStatus === 'Not started' ? (
                        <button
                          className={`back-btn`}
                          onClick={() => { this.setState({ route: '/FinishProductSampleEntryDetails' }) }}
                        >
                          Sample Entry
                        </button>
                      ) : null}

                      {this.state.packingDetails.qcStatus === 'In progress' ? (
                        <button
                          className={`back-btn`}
                          onClick={() => { this.setState({ route: '/FinishProductTestReportEntry' }) }}
                        >
                          Test Report
                        </button>
                      ) : null}
                    </>
                    : null}
                </div>
              </div>
              <div className="itemList-table mt-3.5">
                <div className="table-container" style={{ height: 'calc(100vh - 340px)' }}>
                  <table className="itemList">
                    <thead>
                      <tr>
                        <td className="w-3/5">Material Name</td>
                        <td className="w-1/10">Quantity</td>
                        <td className="w-1/10">UOM</td>
                        <td className="w-1/10">Stock</td>
                      </tr>
                    </thead>
                    {this.state.pmFormulaList &&
                      this.state.pmFormulaList.length > 0 ? (
                      this.state.pmFormulaList.map((item, key) => (
                        <tbody key={key}>
                          <tr
                            className={`hover:bg-gray-200 cursor-pointer 
                              ${Number(item.netQty) >
                                Number(item.totalStock)
                                ? "text-red-600"
                                : ""
                              }`}
                            onClick={() => {
                              this.setState({
                                isQtyEditingKey: key,
                                updatedQty:
                                  Number(item.netQty),
                              });
                              if (!this.state.isQtyEditing) {
                                this.setState({
                                  isQtyEditing: true,
                                });
                              }
                            }}
                          >
                            <td>{item.pmName}</td>
                            <td>
                              {this.state.isQtyEditing === true &&
                                this.state.packingDetails
                                  .productionStageStatusId < 4 &&
                                key ===
                                (this.state.isQtyEditingKey >= 0
                                  ? this.state.isQtyEditingKey
                                  : null) ? (
                                <div class="flex items-center space-x-2">
                                  <input
                                    className="inputFocus "
                                    type="number"
                                    id="updatedQty"
                                    name="updatedQty"
                                    autoComplete="off"
                                    class="h-7 w-[80%] w-20 px-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-sky-500"
                                    value={this.state.updatedQty}
                                    onChange={(event) =>
                                      this.handleQtyChange(event)
                                    }
                                  />
                                  <button
                                    class="h-[28px] w-[28px] p-[5px] bg-sky-600 text-white rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-sky-500"
                                    onClick={() =>
                                      this.updateQtyForPMFormula(item, key)
                                    }
                                  >
                                    <FontAwesomeIcon icon={faCheck} className="w-full h-full" />
                                  </button>
                                </div>
                              ) : (
                                item.isUpdatedQty === true ?
                                  item.netQty.toFixed(3)
                                  :
                                  Number(item.netQty).toFixed(3)
                              )}
                            </td>
                            <td>{item.pmUOM ? item.pmUOM : item.uom}</td>
                            <td>{item.totalStock}</td>
                          </tr>
                        </tbody>
                      ))
                    ) : this.state.pmFormulaList
                      && this.state.pmFormulaList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={4} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.pmFormulaList
                      && this.state.pmFormulaList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                    {/* <tbody>
                      <tr>
                        <td>252658</td>
                        <td>01/10/2025</td>
                        <td>Zyden</td>
                        <td>Software</td>
                        <td style={{ textAlign: "center" }}>
                          <button className="search-btn mr-2.5">
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody className="validation-body">
                      <tr>
                        <td
                          colSpan={5}
                          style={{ textAlign: "center", fontSize: "16px" }}
                        >
                          No Records Found
                        </td>
                      </tr>
                    </tbody> */}
                  </table>
                </div>
              </div>
            </div>
          ) : null}
        </div>

        <ProductionPMSlipModel
          setRMSlipModel={this.state.setRMSlipModel}
          setModalOpen={this.setOpenModel.bind(this)}
          isPrintButtonHide={this.state.isPrintButtonHide}
          printData={this.printData.bind(this)}
          pmFormulaList={this.state.pmFormulaList}
          packingDetails={this.state.packingDetails}
          printRef={this.printRef}
        />
      </>
    );
  }
}

export default PackingRequisition;
